import { render } from "./LandlordHeader.vue?vue&type=template&id=a70a29a2&scoped=true"
import script from "./LandlordHeader.vue?vue&type=script&lang=js"
export * from "./LandlordHeader.vue?vue&type=script&lang=js"

import "./LandlordHeader.vue?vue&type=style&index=0&id=a70a29a2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a70a29a2"]])

export default __exports__